'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CalendarController = function () {
	/*@ngInject*/
	function CalendarController(Modal, $http, $filter, $uibModal, $compile, $timeout, copyTextToClipboard, ColorFinder, HourFinder, StartFinder, ValidIndexes, DateFinder) {
		_classCallCheck(this, CalendarController);

		this.Modal = Modal;
		this.$http = $http;
		this.$filter = $filter;
		this.$uibModal = $uibModal;
		this.$compile = $compile;
		this.$timeout = $timeout;
		this.copyTextToClipboard = copyTextToClipboard;
		this.ColorFinder = ColorFinder;
		this.HourFinder = HourFinder;
		this.StartFinder = StartFinder;
		this.ValidIndexes = ValidIndexes;
		this.DateFinder = DateFinder;
	}

	_createClass(CalendarController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.isSandbox = location.host.includes('sandbox');

			this.visibleLessons = [];

			this.intDay();

			this.icons = {
				first: '',
				second: '',
				third: '',
				fourth: '',
				fifth: '',
				sixth: '',
				year12: ''
			};

			this.clearIconFilters();

			this.$http.get('/api/icons').then(function (response) {
				if (response && response.data && response.data[0]) {
					_this.icons = response.data[0];
				}
				_this.finishedLoad();
			});

			this.$http.get('/api/termsettings').then(function (response) {
				if (response && response.data && response.data[0]) {
					_this.term = response.data[0];
				}
				_this.finishedLoad();
			});

			this.location = 'paddington';

			this.rooms = {
				'paddington': this.createArray(7),
				'cannon hill': this.createArray(6),
				'online': this.createArray(12)

			};

			this.segments = this.createArray(48);

			this.loading = true;
			this.loaded = 0;

			this.$http.get('/api/lessons').then(function (response) {
				_this.sessions = response.data;
				_this.finishedLoad();
			});

			this.$http.get('/api/students').then(function (response) {
				_this.students = response.data;
				_this.finishedLoad();
			});

			this.$http.get('/api/tutors').then(function (response) {
				_this.tutors = response.data;
				_this.finishedLoad();
			});

			var changeColour = function changeColour(colour) {
				colour = colour.toLowerCase();
				return function ($itemScope, $event) {
					var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var _uid = _targ.dataset.id;
					var _instance = +_targ.dataset.instance;
					_this.editColour(_uid, _instance, colour);
				};
			};

			var tempColourChildren = ['Yellow', 'Green', 'Dark Green', 'Orange', 'Purple', 'Red', 'Dark Red'];
			tempColourChildren = tempColourChildren.map(function (item) {
				return {
					text: item,
					click: changeColour(item)
				};
			});

			var changeIcon = function changeIcon(icon, perm) {
				return function ($itemScope, $event) {
					var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var _uid = _targ.dataset.id;
					var _instance = +_targ.dataset.instance;
					_this.editIcon(_uid, _instance, icon, perm);
				};
			};

			var menuDisplayed = function menuDisplayed($itemScope, $event) {
				return !!($event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell'));
			};

			var dateSame = function dateSame($itemScope, $event) {
				var today = new Date();
				var tomorrow = new Date();
				tomorrow.setDate(today.getDate() + 1);
				return menuDisplayed($itemScope, $event) && (_this.calendarDate.toDateString() === today.toDateString() || _this.calendarDate.toDateString() === tomorrow.toDateString());
			};

			this.menuOptions = [{
				text: 'Add Session',
				hasBottomDivider: true,
				click: function click($itemScope, $event) {
					console.log($itemScope, $event);
					var _time = 1440 / _this.segments.length * $itemScope.$parent.segment;
					_this.addSessionModal(_time, $itemScope.room);
				}
			}, {
				text: 'Copy',
				displayed: menuDisplayed,
				children: [{
					text: 'Phone Number',
					click: function click($itemScope, $event) {
						var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.phone : $event.target.closest('.session-cell').dataset.phone;
						_this.copyTextToClipboard(text);
					}
				}, {
					text: 'Email Address',
					click: function click($itemScope, $event) {
						var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.email : $event.target.closest('.session-cell').dataset.email;
						_this.copyTextToClipboard(text);
					}
				}]
			}, {
				text: 'Delete',
				hasBottomDivider: true,
				displayed: menuDisplayed,
				children: [{
					text: 'Instance',
					click: function click($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						_this.overwriteHide(_uid, _instance);
					}
				}, {
					text: 'Series',
					click: function click($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						if (confirm('Are you sure you want to permanently delete this series?')) {
							_this.deleteSeries(_uid);
						}
					}
				}]
			}, {
				text: 'SMS Student',
				displayed: dateSame,
				click: function click($itemScope, $event) {
					var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var _uid = _targ.dataset.id;
					var _instance = +_targ.dataset.instance;
					var _time = $itemScope.$parent.segment;
					_this.sendSMS(_uid, _instance, _time, false);
				}
			}, {
				text: 'SMS Tutor',
				hasBottomDivider: true,
				displayed: dateSame,
				click: function click($itemScope, $event) {
					var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var _uid = _targ.dataset.id;
					var _instance = +_targ.dataset.instance;
					var _time = $itemScope.$parent.segment;
					_this.sendSMS(_uid, _instance, _time, true);
				}
			}, {
				text: 'Email Tutor',
				children: [{
					text: 'This Day',
					click: function click($itemScope, $event) {
						var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var uid = targ.dataset.id;
						_this.sendEmail(uid, _this.calendarDate, false, false);
					}
				}, {
					text: 'This Day - With Subjects',
					click: function click($itemScope, $event) {
						var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var uid = targ.dataset.id;
						_this.sendEmail(uid, _this.calendarDate, false, true);
					}
				}, {
					text: 'This Week',
					click: function click($itemScope, $event) {
						var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var uid = targ.dataset.id;
						_this.sendEmail(uid, _this.calendarDate, true, false);
					}
				}, {
					text: 'This Week - With Subjects',
					click: function click($itemScope, $event) {
						var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var uid = targ.dataset.id;
						_this.sendEmail(uid, _this.calendarDate, true, true);
					}
				}]
			}, {
				text: 'Email Student Schedule',
				hasBottomDivider: true,
				click: function click($itemScope, $event) {
					var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var uid = targ.dataset.id;
					_this.sendEmailScheduleNotif(uid, _this.calendarDate);
				}
			}, {
				text: 'Temporary Icon',
				displayed: menuDisplayed,
				children: [{
					text: '1. Paid',
					click: changeIcon(1, false)
				}, {
					text: '2. New Client',
					click: changeIcon(2, false)
				}, {
					text: '5. Tick',
					click: changeIcon(5, false)
				}, {
					text: '6. Cross',
					click: changeIcon(6, false)
				}, {
					text: 'Unknown',
					click: changeIcon(7, false)
				}]
			}, {
				text: 'Permanent Icon',
				displayed: menuDisplayed,
				hasBottomDivider: true,
				children: [{
					text: '3. Different Pay Rate',
					click: changeIcon(3, true)
				}, {
					text: '4. Payment Stored',
					click: changeIcon(4, true)
				}, {
					text: 'Direct Debit',
					click: changeIcon(8, true)
				}, {
					text: 'Credit Card Stored',
					click: changeIcon(9, true)
				}]
			}, {
				text: 'Toggle Changeover',
				hasBottomDivider: true,
				displayed: menuDisplayed,
				click: function click($itemScope, $event) {
					var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
					var _uid = _targ.dataset.id;
					var _instance = +_targ.dataset.instance;
					_this.overwriteChangeover(_uid, _instance);
				}
			}, {
				text: 'Close'
			}];
		}
	}, {
		key: 'intDay',
		value: function intDay() {
			var today = new Date();

			this.calendarDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		}
	}, {
		key: 'editColour',
		value: function editColour(id, instance, colour) {
			var _this2 = this;

			var session = this.sessions.find(function (session) {
				return id == session._id;
			});

			session.overwriteColor = session.overwriteColor || {};
			session.overwriteColor[instance] = colour;
			this.$http.put('/api/lessons/' + id, {
				overwriteColor: session.overwriteColor
			}).then(function (response) {
				_this2.clearCal();
			});
		}
	}, {
		key: 'clearMessages',
		value: function clearMessages() {
			this.tempSuccess = null;
		}
	}, {
		key: 'studentInactive',
		value: function studentInactive(id, instance) {
			var _this3 = this;

			var session = this.sessions.find(function (session) {
				return id == session._id;
			});

			this.$http.put('/api/students/' + session.student._id, {
				isActive: false
			}).then(function (response) {
				_this3.clearCal();
			});
		}
	}, {
		key: 'clearIconFilters',
		value: function clearIconFilters() {
			this.iconFilters = {
				first: false,
				second: false,
				third: false,
				fourth: false,
				fifth: false,
				sixth: false,
				year12: false
			};
		}
	}, {
		key: 'sendEmail',
		value: function sendEmail(id, date, isWeek, withSubjects) {
			var _this4 = this;

			var msDay = 1000 * 60 * 60 * 24;
			if (isWeek) {
				if (date.getDay() === 0) {
					var startOfWeek = date.getDate() - 7;
				} else {
					var startOfWeek = date.getDate() - (date.getDay() - 1);
				}

				var start = new Date(date.getFullYear(), date.getMonth(), startOfWeek);
				var end = new Date(date.getFullYear(), date.getMonth(), startOfWeek + 6);
			} else {
				var start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
				var end = start;
			}

			var tutorInfo = [];
			var tutorID = this.sessions.find(function (session) {
				return id == session._id;
			}).tutorUID;
			var tutor = this.tutors.find(function (tutor) {
				return tutorID === tutor._id;
			});
			var tutorSessions = this.sessions.filter(function (session) {
				return tutorID === session.tutorUID;
			}).filter(function (session) {
				return session.date;
			});

			var sessionData = [];

			tutorSessions.forEach(function (session) {
				var validIndexes = _this4.ValidIndexes(session, start, end);

				validIndexes.forEach(function (index) {

					var basicTime = _this4.StartFinder(session, index);

					console.log(basicTime);
					var formattedTime = _this4.$filter('minuteConvert')(basicTime, false);
					var sessionDate = _this4.DateFinder(session, index);
					var formattedDate = _this4.$filter('toDateString')(sessionDate);
					var color = _this4.ColorFinder(session, index);

					sessionData.push({
						studentName: session.student.firstName + " " + session.student.lastName,
						isTertiary: session.student.isTertiary,
						grade: session.student.grade,
						subjects: session.student.subjects,
						time: formattedTime,
						isEmpty: false,
						basicTime: basicTime,
						date: formattedDate,
						sessionDate: sessionDate,
						color: color
					});
				});
			});

			if (!isWeek) {
				sessionData = sessionData.filter(function (session) {
					var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
					var color = session.color.toLowerCase();

					return acceptedColors.includes(color);
				});
			};

			if (sessionData.length === 0) {
				return alert('Something went wrong. No sessions found.');
			}

			var datesPresent = [];
			sessionData.forEach(function (session) {
				if (datesPresent.includes(session.date) === false) {
					datesPresent.push(session.date);
				};
			});

			var times = [930, 990, 1050, 1110, 1170, 1230, 1290];

			datesPresent.forEach(function (datePresent) {
				var filteredSessions = sessionData.filter(function (session) {
					return session.date === datePresent;
				});

				times.forEach(function (time) {
					var found = filteredSessions.find(function (session) {
						return session.basicTime === time;
					});

					if (!found) {
						var formattedTime = _this4.$filter('minuteConvert')(time, false);
						var sessionDate = _this4.$filter('reparseDate')(datePresent);

						sessionData.push({
							basicTime: time,
							isEmpty: true,
							date: datePresent,
							time: formattedTime,
							sessionDate: sessionDate
						});
					}
				});
			});

			sessionData = sessionData.sort(function (a, b) {
				if (a.sessionDate < b.sessionDate) {
					return -1;
				}

				if (a.sessionDate > b.sessionDate) {
					return 1;
				}

				if (a.basicTime < b.basicTime) {
					return -1;
				}

				if (a.basicTime > b.basicTime) {
					return 1;
				}

				return 0;
			}).filter(function (session) {
				return !session.isEmpty;
			});

			var dates = new Set(sessionData.map(function (session) {
				return session.sessionDate;
			}));

			var tutorWeek = [];

			dates.forEach(function (date) {
				var sessionsOnDay = sessionData.filter(function (session) {
					return session.sessionDate == date;
				});
				var thisDate = new Date(date).toLocaleDateString('en-AU', { weekday: 'long' });
				console.log(sessionsOnDay);
				tutorWeek.push(_defineProperty({}, thisDate, sessionsOnDay));
			});

			var schedule = '<ul>';

			tutorWeek.forEach(function (day) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {

					for (var _iterator = Object.entries(day)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _step$value = _slicedToArray(_step.value, 2),
						    key = _step$value[0],
						    value = _step$value[1];

						schedule += '\t<li>' + key + '<ul>';
						value.forEach(function (studentSession) {

							if (studentSession.isTertiary) {
								var grade = '(Uni Student)';
							} else {
								var grade = '(Year ' + studentSession.grade + ')';
							}

							if (withSubjects && studentSession.subjects) {
								var subjects = ' ' + studentSession.subjects;
							} else {
								var subjects = "";
							}

							schedule += '<li>' + studentSession.time + ' - ' + studentSession.studentName + ' ' + grade + subjects + '</li>\n';
						});

						schedule += '</ul></li>\n';
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			});

			schedule += '</ul>';

			var month = ("0" + (start.getMonth() + 1)).slice(-2);
			var date = ("0" + start.getDate()).slice(-2);
			var subjectDate = date + "/" + month;

			this.$http.post('/api/tutors/send-email/day', {
				content: schedule,
				range: isWeek ? 'Week Commencing (' + subjectDate + ')' : 'DAY (' + subjectDate + ')',
				tutor: tutor.firstName + ' ' + tutor.lastName,
				emailAddress: tutor.email
			});
		}
	}, {
		key: 'sendEmailScheduleNotif',
		value: function sendEmailScheduleNotif(id, date) {
			var _this5 = this;

			var start = new Date(this.term.startDate);
			var end = new Date(this.term.endDate);
			var termNo = this.term.termNo;
			var sixthSunday = this.term.sixthSunday;

			var weekEnderResults = [];
			var day = 0;
			var current = new Date(start);

			current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
			end.setDate(end.getDate() + (7 - end.getDay()) % 7);

			while (current <= end) {
				var weekEnder = new Date(+current);
				weekEnderResults.push({
					value: weekEnder,
					duration: 0
				});
				current.setDate(current.getDate() + 7);
			}

			var studentId = this.sessions.find(function (session) {
				return id == session._id;
			}).clientUID;
			var student = this.sessions.find(function (session) {
				return id == session._id;
			}).student;

			var sessionData = [];
			var sessions = this.sessions.filter(function (session) {
				return session.clientUID == studentId;
			});

			sessions.forEach(function (session) {
				var validIndexes = _this5.ValidIndexes(session, start, end);

				validIndexes.forEach(function (index) {

					var sessionDate = _this5.DateFinder(session, index);
					var formattedDate = _this5.$filter('toDateString')(sessionDate);
					var parsedDate = _this5.$filter('reparseDate')(formattedDate);
					var color = _this5.ColorFinder(session, index);
					sessionData.push({
						duration: session.duration / 60,
						sessionDate: sessionDate,
						date: parsedDate,
						color: color
					});
				});
			});

			sessionData = sessionData.filter(function (session) {
				var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
				var color = session.color.toLowerCase();
				return acceptedColors.includes(color);
			});

			sessionData = sessionData.sort(function (a, b) {
				if (a.sessionDate < b.sessionDate) {
					return -1;
				}

				if (a.sessionDate > b.sessionDate) {
					return 1;
				}

				if (a.basicTime < b.basicTime) {
					return -1;
				}

				if (a.basicTime > b.basicTime) {
					return 1;
				}

				return 0;
			});

			var hoursCompleted = 0;
			var weekList = [];

			weekEnderResults.forEach(function (weekend, i, weekends) {
				var weekendDate = new Date(weekend.value);

				sessionData.forEach(function (session) {
					var sessionDate = new Date(session.date);
					if (i == 0 && sessionDate <= weekendDate) {
						weekend.duration += session.duration;
					} else if (i > 0) {
						var weekendStart = new Date(weekends[i - 1].value);
						if (sessionDate >= weekendStart && sessionDate <= weekendDate) {
							weekend.duration += session.duration;
						}
					}
				});

				var month = ("0" + (weekendDate.getMonth() + 1)).slice(-2);
				var date = ("0" + weekendDate.getDate()).slice(-2);

				var status = i > 4 ? 'Scheduled' : 'Completed';
				var toBeRescheduled = false;
				if (i >= 0 && i <= 4) {
					hoursCompleted += weekend.duration;
					if (weekend.duration == 0) {
						status += " (To Be Rescheduled)";
						toBeRescheduled = true;
					}
				} else if (i == 9) {
					status += '  (Does This Session Need To Be Rescheduled?)';
				}
				weekList.push({
					value: 'Week Ending ' + date + '/' + month + ' - ' + weekend.duration + ' Hour ' + status,
					toBeRescheduled: toBeRescheduled
				});
			});

			var studentInfo = {
				clientEmailAddress: student.clientEmail,
				clientName: student.clientFirstName,
				studentName: student.firstName,
				termNo: termNo,
				sixthSunday: sixthSunday,
				hoursCompleted: hoursCompleted,
				hoursToFinish: 10 - hoursCompleted,
				weekList: weekList
			};

			console.log(studentInfo);

			this.$http.post('/api/students/send-email-notif', {
				subject: 'Tuition Schedule to Finish Term ' + termNo,
				studentInfo: [studentInfo]
			});
		}
	}, {
		key: 'sendSMS',
		value: function sendSMS(id, instance, time, isTutor) {
			var session = this.sessions.find(function (session) {
				return id == session._id;
			});
			var tutor = session.tutor;
			var student = session.student;

			var today = new Date();
			var tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);
			var isTomorrow = this.calendarDate.toDateString() === tomorrow.toDateString();

			this.sendSMSModal(student, time, tutor, isTutor, isTomorrow);
		}
	}, {
		key: 'colourCountModal',
		value: function colourCountModal() {
			var _todaysSessions = this.todaysSessions();
			var _calendarDate = this.calendarDate;

			this.$uibModal.open({
				template: require('./colour-count/colour-count.html'),
				controller: 'ColourCountController',
				controllerAs: 'vm',
				resolve: {
					todaysSessions: function todaysSessions() {
						return _todaysSessions;
					},
					calendarDate: function calendarDate() {
						return _calendarDate;
					}
				}
			});
		}
	}, {
		key: 'sendSMSModal',
		value: function sendSMSModal(student, time, tutor, isTutor, isTomorrow) {
			var _this6 = this;

			this.$uibModal.open({
				template: require('./send-sms/send-sms.html'),
				controller: 'SendSMSController',
				controllerAs: 'vm',
				resolve: {
					data: function data() {
						return {
							student: student,
							time: time,
							tutor: tutor,
							isTutor: isTutor,
							isTomorrow: isTomorrow
						};
					}
				}
			}).result.then(function (res) {
				_this6.tempSuccess = true;
			});
		}
	}, {
		key: 'editIcon',
		value: function editIcon(id, instance, icon, perm) {
			var _this7 = this;

			var session = this.sessions.find(function (session) {
				return id == session._id;
			});

			if (perm) {
				var key = 'var' + String(icon);
				var property = !session.student[key];
				var change = _defineProperty({}, key, property);

				this.$http.put('/api/students/' + session.student._id, change).then(function (response) {
					var student = _this7.students.find(function (s) {
						return s._id === session.student._id;
					});
					student[key] = property;

					_this7.clearCal();
				});

				return;
			}

			var key = 'overwriteVar' + String(icon);
			session[key] = session[key] || {};
			session[key][instance] = !session[key][instance];
			var change = _defineProperty({}, key, session[key]);

			this.$http.put('/api/lessons/' + id, change).then(function (response) {
				_this7.clearCal();
			});
		}
	}, {
		key: 'deleteSeries',
		value: function deleteSeries(id) {
			var _this8 = this;

			var index = this.sessions.find(function (s) {
				return s._id === id;
			});
			this.sessions = [].concat(_toConsumableArray(this.sessions.slice(0, index)), _toConsumableArray(this.sessions.slice(index + 1)));
			this.$http.delete('/api/lessons/' + id).then(function (res) {
				_this8.clearCal();
			});
		}
	}, {
		key: 'overwriteHide',
		value: function overwriteHide(id, instance) {
			var _this9 = this;

			this.sessions.forEach(function (session) {
				if (id == session._id) {
					session.overwriteVisibility = session.overwriteVisibility || {};
					session.overwriteVisibility[instance] = true;
					_this9.$http.put('/api/lessons/' + id, {
						overwriteVisibility: session.overwriteVisibility
					}).then(function (response) {
						_this9.clearCal();
					});
				}
			});
		}
	}, {
		key: 'overwriteChangeover',
		value: function overwriteChangeover(id, instance) {
			var _this10 = this;

			this.sessions.forEach(function (session) {
				if (id == session._id) {
					session.overwriteChangeover = session.overwriteChangeover || {};
					if (typeof session.overwriteChangeover[instance] === 'undefined') {
						session.overwriteChangeover[instance] = false;
					} else {
						session.overwriteChangeover[instance] = !session.overwriteChangeover[instance];
					}

					_this10.$http.put('/api/lessons/' + id, {
						overwriteChangeover: session.overwriteChangeover
					}).then(function (response) {
						_this10.clearCal();
					});
				}
			});
		}
	}, {
		key: 'iconFilterChange',
		value: function iconFilterChange(key) {
			this.iconFilters[key] = !this.iconFilters[key];
			this.clearCal();
		}
	}, {
		key: 'finishedLoad',
		value: function finishedLoad() {
			this.loaded++;
			if (this.loaded === 5) {
				this.updateCal();
			}
		}
	}, {
		key: 'todaysSessions',
		value: function todaysSessions() {
			var _this11 = this;

			var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
			var cleanDate = this.$filter('reparseDate')(parsedDate);
			var sessions = this.sessions;

			sessions = sessions.filter(function (session) {
				if (!session.date) {
					console.log(session);
					return;
				}

				var objSession = _this11.$filter('reparseDate')(session.date);
				var daysAhead = Math.round((cleanDate - objSession) / 86400000);
				var instance = daysAhead / session.frequency;

				if (_this11.iconFilters.first && (!session.overwriteVar1 || session.overwriteVar1[instance] !== true)) {
					return;
				}

				if (_this11.iconFilters.second && (!session.overwriteVar2 || session.overwriteVar2[instance] !== true)) {
					return;
				}

				if (_this11.iconFilters.third && session.student.var3 !== true) {
					return;
				}

				if (_this11.iconFilters.fourth && session.student.var4 !== true) {
					return;
				}

				if (_this11.iconFilters.fifth && (!session.overwriteVar5 || session.overwriteVar5[instance] !== true)) {
					return;
				}

				if (_this11.iconFilters.sixth && (!session.overwriteVar6 || session.overwriteVar6[instance] !== true)) {
					return;
				}

				if (_this11.iconFilters.year12 && session.student.grade !== 12) {
					return;
				}

				return true;
			});

			sessions = sessions.map(function (session) {
				if (!session.student && session.clientUID) {
					session.student = _this11.students.find(function (s) {
						return s._id === session.clientUID;
					});
				}

				if (!session.tutor && session.tutorUID) {
					session.tutor = _this11.tutors.find(function (t) {
						return t._id === session.tutorUID;
					});
				}
				return session;
			});

			if (this.searchFilter) sessions = this.$filter('filter')(this.sessions, this.searchFilter);

			var filteredSessions = sessions.filter(function (session) {
				if (session.isHidden) return;

				if (session.location != _this11.location) return;

				if (session.date == parsedDate) return true;

				console.log(session);

				if (session.instances == 1) return;

				var objSession = _this11.$filter('reparseDate')(session.date);

				if (objSession > cleanDate) return;

				var daysAhead = Math.round((cleanDate.getTime() - objSession.getTime()) / 86400000);

				if (daysAhead % session.frequency !== 0) return;

				var _instance = daysAhead / session.frequency;

				if (session.instances === 0) return true;

				if (session.instances > _instance) return true;
			});

			return filteredSessions.map(function (session) {
				if (session.date == parsedDate) {
					session._instance = 0;
					return session;
				};

				var objSession = _this11.$filter('reparseDate')(session.date);
				var daysAhead = Math.round((cleanDate - objSession) / 86400000);
				var _instance = daysAhead / session.frequency;

				session._instance = _instance;

				return session;
			});
		}
	}, {
		key: 'updateCal',
		value: function updateCal() {
			var _this12 = this;

			this.visibleLessons = [];
			var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
			var cleanDate = this.$filter('reparseDate')(parsedDate);
			var todaysSessions = this.todaysSessions();

			todaysSessions.forEach(function (session) {
				if (!session) {
					console.log(todaysSessions);
					return;
				}

				if (session.date == parsedDate) return _this12.addCalendar(session, 0);

				var objSession = _this12.$filter('reparseDate')(session.date);

				var daysAhead = Math.round((cleanDate - objSession) / 86400000);

				var _instance = daysAhead / session.frequency;

				_this12.addCalendar(session, _instance);
			});

			this.addDropAndDrag();
		}
	}, {
		key: 'handleClick',
		value: function handleClick($event) {
			var _targ = $event.target.classList.contains('free-col') ? $event.target : $event.target.closest('.free-col');
			var _startTime = _targ.dataset.time;
			var _room = _targ.dataset.room;

			if (_targ.childElementCount === 0) {
				return this.addSessionModal(_startTime, _room);
			}

			var closest = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
			var finalTarg = closest || _targ.firstChild;
			var _uid = finalTarg.dataset.id;
			var _instance = +finalTarg.dataset.instance;

			this.editSessionModal(_uid, _instance);
		}
	}, {
		key: 'addDropAndDrag',
		value: function addDropAndDrag() {
			var _this13 = this;

			var drop = function drop(ev) {
				ev.preventDefault();
				var id = ev.dataTransfer.getData("text");
				var el = document.querySelector('[data-id="' + id + '"]');
				if (ev.target.appendChild(el)) {
					var instance = +el.dataset.instance;
					var time = +ev.target.dataset.time;
					var room = +ev.target.dataset.room;

					var session = _this13.sessions.find(function (session) {
						return id == session._id;
					});
					if (!session) {
						return;
					}
					session.overwriteStart = session.overwriteStart || {};
					session.overwriteStart[instance] = time;
					session.overwriteRoom = session.overwriteRoom || {};
					session.overwriteRoom[instance] = room;

					_this13.$http.put('/api/lessons/' + id, {
						overwriteRoom: session.overwriteRoom,
						overwriteStart: session.overwriteStart
					}).then(function (response) {
						_this13.clearCal();
					});
				}
			};

			var allowDrop = function allowDrop(ev) {
				ev.preventDefault();
			};

			var dragEnter = function dragEnter() {
				this.classList.add('drag-cell');
			};

			var dragLeave = function dragLeave() {
				this.classList.remove('drag-cell');
			};

			var dragStart = function dragStart(ev) {
				ev.dataTransfer.setData("text", ev.target.dataset.id);
				this.classList.add('in-drag');
				this.closest('table').classList.add('in-drag');
			};

			var dragStop = function dragStop() {
				document.querySelectorAll('.in-drag').forEach(function (item) {
					item.classList.remove('in-drag');
				});
				document.querySelectorAll('.drag-cell').forEach(function (item) {
					item.classList.remove('drag-cell');
				});
			};

			document.querySelectorAll('.free-col').forEach(function (item) {
				item.ondrop = drop;
				item.ondragover = allowDrop;
				item.ondragenter = dragEnter;
				item.ondragleave = dragLeave;
			});

			document.querySelectorAll('.session-cell').forEach(function (item) {
				item.ondragstart = dragStart;
			});

			document.ondragend = dragStop;
			document.ondrop = dragStop;

			var el = document.querySelector('.table-wrap');
			if (this.loading || this.changingDay) {
				el.scrollTop = 432;
			}

			this.changingDay = false;
			this.loading = false;
		}
	}, {
		key: 'reloadCal',
		value: function reloadCal() {
			var _this14 = this;

			this.$http.get('/api/lessons').then(function (response) {
				_this14.sessions = response.data;
				_this14.clearCal();
			});
		}
	}, {
		key: 'reloadStudents',
		value: function reloadStudents() {
			var _this15 = this;

			this.$http.get('/api/students').then(function (response) {
				_this15.students = response.data;
				_this15.reloadCal();
			});
		}
	}, {
		key: 'addSessionModal',
		value: function addSessionModal(startTime, room) {
			var _this16 = this;

			this.$uibModal.open({
				template: require('./modal/add-session.html'),
				controller: 'SessionController',
				controllerAs: 'vm',
				windowClass: 'session-modal',
				resolve: {
					data: function data() {
						return {
							startTime: startTime,
							room: room,
							location: _this16.location,
							date: _this16.calendarDate
						};
					}
				}
			}).result.then(function (res) {
				if (res.reason == 'success') {
					_this16.tempSuccess = true;
					_this16.sessions.push(res.data);
					_this16.clearCal();
				}
			});
		}
	}, {
		key: 'editSessionModal',
		value: function editSessionModal(uid, instance) {
			var _this17 = this;

			var _data = this.sessions.find(function (item) {
				return item._id == uid;
			});

			if (!_data) return;

			_data.aInstance = instance;

			this.$uibModal.open({
				template: require('./modal/edit-session.html'),
				controller: 'EditSessionController',
				controllerAs: 'vm',
				windowClass: 'session-modal',
				resolve: {
					data: function data() {
						return _data;
					}
				}
			}).result.then(function (res) {
				if (res.reason == 'success') {
					_this17.tempSuccess = true;
					var index = _this17.sessions.findIndex(function (s) {
						return s._id === res.data._id;
					});
					_this17.sessions[index] = res.data;

					_this17.clearCal();
				}
			});
		}
	}, {
		key: 'clearCal',
		value: function clearCal(delayUpdate) {
			var _this18 = this;

			console.log('clearing calendar');
			document.querySelectorAll('.session-cell').forEach(function (item) {
				item.parentNode.removeChild(item);
			});
			if (delayUpdate) {
				this.$timeout(function () {
					_this18.updateCal();
				}, 300);
			} else {
				this.updateCal();
			}
		}
	}, {
		key: 'scrubAll',
		value: function scrubAll() {
			var _this19 = this;

			this.$http.get('/api/lessons/scrub-all').then(function (response) {
				_this19.reloadStudents();
			});
		}
	}, {
		key: 'scrubDay',
		value: function scrubDay() {
			var _this20 = this;

			this.$http.post('/api/lessons/scrub-day', { list: this.visibleLessons }).then(function (response) {
				_this20.reloadStudents();
			});
		}
	}, {
		key: 'addCalendar',
		value: function addCalendar(session, instance) {

			if (session.overwriteVisibility && session.overwriteVisibility[instance]) {
				return;
			}

			this.visibleLessons.push(session._id);

			var identifier = 't' + session.startTime + 'r' + session.room;


			var specificNotes = session.overwriteNotes && instance in session.overwriteNotes ? session.overwriteNotes[instance] : null;


			var color = this.ColorFinder(session, instance);

			var _div = document.createElement('div');
			if (color.indexOf(' ') != -1) {
				var _temp = color.split(' ');
				color = _temp[1] + ' ' + _temp[0];
			}
			_div.className = 'session-cell';
			_div.id = 'a-' + identifier;
			_div.setAttribute('draggable', 'true');
			_div.setAttribute('data-id', session._id);
			_div.setAttribute('data-phone', session.student.clientPh);
			_div.setAttribute('data-email', session.student.clientEmail);
			_div.setAttribute('data-instance', instance);

			var _duration = this.HourFinder(session, instance);
			_div.style.height = 'calc(' + String(100 * (_duration / 30)) + '% - 4px)';
			if (_duration < 60) _div.className += ' single-cell';

			var isChangeover = session.overwriteChangeover && instance in session.overwriteChangeover ? session.overwriteChangeover[instance] : session.changeover;
			if (isChangeover) {
				_div.className += ' changeover';
			}

			if (session.isChangeover && session.isChangeover[instance]) _div.className += ' changeover';

			if (session.overwriteName && session.overwriteName[instance]) {
				_div.innerHTML = '<span class="student">' + session.overwriteName[instance] + '</span>';
			} else {
				_div.innerHTML = '<span class="student">' + session.student.firstName + ' ' + session.student.lastName + '</span>';
			}

			_div.innerHTML += '<span class="tutor">' + session.tutor.firstName + ' ' + session.tutor.lastName + '</span>';

			var compiledNotes = '';
			if (session.globalNotes) {
				_div.innerHTML += '<br><span class="notes global-notes">' + session.globalNotes + '</span>';
				compiledNotes += 'Global Notes: \n' + session.globalNotes + '\n';
			}
			if (specificNotes) {
				_div.innerHTML += '<br><span class="notes specific-notes">' + specificNotes + '</span>';
				compiledNotes += 'Specific Notes: \n' + specificNotes + '\n';
			}

			if (session.student.clientFirstName || session.student.clientLastName) {
				compiledNotes += 'Contact Name: ' + session.student.clientFirstName + ' ' + session.student.clientLastName + '\n';
			}

			if (session.student.clientPh) {
				compiledNotes += 'Contact Number: ' + session.student.clientPh + '\n';
			}

			if (session.student.grade) {
				compiledNotes += 'Student Year: ' + session.student.grade + '\n';
			}

			if (session.student.subjects) {
				compiledNotes += 'Subjects: ' + session.student.subjects;
			}

			if (session.tutor && session.tutor.phone) {
				compiledNotes += 'Tutor Number: ' + session.tutor.phone + '\n';
			}

			_div.setAttribute('title', compiledNotes);

			var _icons = '';
			if (session.overwriteVar1 && session.overwriteVar1[instance] === true) _icons += '<i class="fa fa-' + this.icons.first + ' norm-icon" aria-hidden="true"></i>';
			if (session.overwriteVar2 && session.overwriteVar2[instance] === true) _icons += '<i class="fa fa-' + this.icons.second + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.var3) _icons += '<i class="fa fa-' + this.icons.third + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.var4) _icons += '<i class="fa fa-' + this.icons.fourth + ' norm-icon" aria-hidden="true"></i>';
			if (session.overwriteVar5 && session.overwriteVar5[instance] === true) _icons += '<i class="fa fa-' + this.icons.fifth + ' norm-icon" aria-hidden="true"></i>';
			if (session.overwriteVar6 && session.overwriteVar6[instance] === true) _icons += '<i class="fa fa-' + this.icons.sixth + ' norm-icon" aria-hidden="true"></i>';
			if (session.overwriteVar7 && session.overwriteVar7[instance] === true) _icons += '<i class="fa fa-' + this.icons._tempUnknown + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.var8) _icons += '<i class="fa fa-' + this.icons._permUnknown + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.var9) _icons += '<i class="fa fa-' + this.icons._perm2Unknown + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.grade == 12) _icons += '<i class="fa fa-' + this.icons.year12 + ' grade-12" aria-hidden="true"></i>';
			if (specificNotes) _icons += '<i class="fa fa-' + this.icons._note + ' norm-icon" aria-hidden="true"></i>';
			if (session.student.price == '$60') _icons += '<i class="fa"><strong>60</strong></i>';
			if (session.student.price == '$70') _icons += '<i class="fa"><strong>70</strong></i>';
			if (session.student.price == '$80') _icons += '<i class="fa"><strong>80</strong></i>';
			if (_icons) _div.innerHTML += '<div class="icon-row">' + _icons + '</div>';

			_div.innerHTML += '<div class="a-bg ' + 'aa' + color + '"></div>';

			var _start = this.StartFinder(session, instance);
			var _room = session.overwriteRoom && instance in session.overwriteRoom ? session.overwriteRoom[instance] : session.room;
			var _targ = document.getElementById('t' + _start + 'r' + _room);

			_targ && _targ.insertBefore(_div, null);
		}
	}, {
		key: 'isCurrentDay',
		value: function isCurrentDay(index) {
			return this.calendarDate.getDay() === index;
		}
	}, {
		key: 'setDayOfWeek',
		value: function setDayOfWeek(index) {
			this.changingDay = true;
			var newIndex = (index + 1) % 7;

			var targetDate = this.calendarDate.getDate() + (newIndex - this.calendarDate.getDay());
			if (this.calendarDate.getDay() === 0) {
				targetDate -= 7;
			} else if (newIndex === 0) {
				targetDate += 7;
			}

			this.calendarDate = new Date(this.calendarDate.setDate(targetDate));
			this.clearCal();
		}
	}, {
		key: 'createArray',
		value: function createArray(length) {
			return Array.apply(null, Array(length)).map(function (x, i) {
				return i;
			});
		}
	}, {
		key: 'addDays',
		value: function addDays(days) {
			this.changingDay = true;
			this.calendarDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), this.calendarDate.getDate() + days);
			this.clearCal();
		}
	}, {
		key: 'changeLocation',
		value: function changeLocation(location) {
			this.changingDay = true;
			this.location = location;
			this.clearCal(true);
		}
	}]);

	return CalendarController;
}();

exports.default = CalendarController;


// WEBPACK FOOTER //
// ./client/app/calendar/calendar.controller.js